module.exports = __webpack_public_path__ + "static/media/037-arab-woman.691cda7d.svg";